ReviewController.$inject = [
  'ApplicationService',
  '$scope',
  '$routeParams',
  '$location',
  '$sce',
  '$window'
];

function ReviewController (ApplicationService, $scope, $routeParams, $location, $sce, $window) {
  var orderedPagesDefault = [
    'GENERAL_INFORMATION',
    'INDEPENDENT_PRODUCER_AGREEMENT',
    'BUSINESS_ASSOCIATE_AGREEMENT',
    'COMMISSION_AGREEMENT',
    'EXHIBIT_A',
    'W9',
    'ASSIGNMENT_OF_COMMISSIONS',
    'ACH_DIRECT_PAYMENT_AUTHORIZATION',
    'E-VERIFY_CERTIFICATION'
  ];
  var orderedPagesForAppointed = [
    'W9',
    'ASSIGNMENT_OF_COMMISSIONS',
    'ACH_DIRECT_PAYMENT_AUTHORIZATION',
    'E-VERIFY_CERTIFICATION'
  ];
  var pageNames = {
    'GENERAL_INFORMATION': {
      name: 'General Information'
    },
    'INDEPENDENT_PRODUCER_AGREEMENT': {
      name: 'Independent Producer Agreement'
    },
    'BUSINESS_ASSOCIATE_AGREEMENT': {
      name: 'Business Associate Agreement'
    },
    'COMMISSION_AGREEMENT': {
      name: 'Commission Agreement'
    },
    'EXHIBIT_A': {
      name: 'Exhibit A'
    },
    'W9': {
      name: 'W9'
    },
    'ASSIGNMENT_OF_COMMISSIONS': {
      name: 'Assignment Of Commissions'
    },
    'ACH_DIRECT_PAYMENT_AUTHORIZATION': {
      name: 'ACH Direct Payment Authorization'
    },
    'E-VERIFY_CERTIFICATION': {
      name: 'E-Verify Certification'
    }
  };
  function init () {
    var data = ApplicationService.getData();
    var currentPage = $routeParams.subRoute;
    $scope.orderedPages = orderedPagesDefault;
    $scope.previouslyAppointed = data.previouslyAppointed;
    if (data.previouslyAppointed) {
      $scope.orderedPages = orderedPagesForAppointed;
    }
    $scope.urlPrefix = '/application';
    var skipAch = false;
    if (data.previouslyAppointed) {
      $scope.urlPrefix += '/update-pay-packet';
      // skip ach assertion if there are no updates to be made
      skipAch = !data.commissionInformation.updateCommissionInformation;
    } else {
      // skip ach if paying via check
      skipAch = data.commissionInformation.payViaCheck;
    }

    if (skipAch) {
      $scope.orderedPages = $scope.orderedPages.filter(function (page) {
        return (page !== 'ACH_DIRECT_PAYMENT_AUTHORIZATION');
      });
    }

    if (!currentPage) {
      currentPage = $scope.orderedPages[0];
      $location.path($scope.urlPrefix + '/review/' + currentPage);
      $location.replace();
      return;
    }
    $scope.page = currentPage;
    $scope.pageName = pageNames[currentPage].name;
    $scope.isLastStep = (($scope.orderedPages.indexOf(currentPage) + 1) === $scope.orderedPages.length);
    $scope.brokerInformation = data.brokerInformation;
    $scope.agreed = false;
    $scope.failure = false;
    $scope.previousStep = previousStep;
    $scope.submitForm = submitForm;
    $scope.htmlUrl = ApplicationService.getHtmlUrl({
      pageName: currentPage
    });
    $scope.pdfUrl = ApplicationService.getPdfUrl({
      pageName: currentPage
    });
    $scope.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };
  }

  function previousStep () {
    var index = $scope.orderedPages.indexOf($scope.page);
    if (index) {
      var previousStep = $scope.orderedPages[index - 1];
      $location.path($scope.urlPrefix + '/review/' + previousStep);
    } else {
      if ($scope.previouslyAppointed) {
        $location.path($scope.urlPrefix + '/information');
      } else {
        $location.path($scope.urlPrefix + '/producer-declaration');
      }
    }
  }

  function submitForm (form) {
    var data = ApplicationService.getData();
    $scope.failure = false;
    if (form.$valid) {
      if ($scope.isLastStep) {
        $scope.loading = true;
        $window.scrollTo(0, 0);
        ApplicationService.submit(true).then(applicationSuccess, applicationFailure);
      } else {
        var index = $scope.orderedPages.indexOf($scope.page);
        var nextStep = $scope.orderedPages[index + 1];
        if (data.previouslyAppointed) {
          $location.path($scope.urlPrefix + '/review/' + nextStep);
        } else {
          $location.path($scope.urlPrefix + '/review/' + nextStep);
        }
      }
    }
  }

  function applicationSuccess () {
    $location.path($scope.urlPrefix + '/thank-you');
  }

  function applicationFailure () {
    $scope.loading = false;
    $scope.failure = true;
  }

  init();
}

export default ReviewController;



//////////////////
// WEBPACK FOOTER
// ./src/js/controllers/ReviewController.js
// module id = 24
// module chunks = 0